module.exports = __webpack_public_path__ + "static/img/Ben_Brown_mobile.c54cabc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben_Brown_mobile.jpg
// module id = LSZZ
// module chunks = 0